import ActionTypes from 'app/refresh/ActionTypes';
import reducer from 'app/refresh/reducer';

export default {
  reducers: {
    refresh: reducer,
  },
  actionTypes: ActionTypes,
};
